export enum ActivationFlow {
  CMB = 'C2C',
  C2GO = 'C2GO',
  C2GO_CMB = 'C2GO_C2C',
  HARDCOVER = 'HARDCOVER',
  RTM = 'RTM',
  NBA = 'NBA',
  OLA = 'OLA',
  MM_SERVICE = 'MM-S'
}
